import meta from 'common/middleware/meta';

import faviconChanger from './faviconChanger';
import analytics from './analytics';
import news from './news';
import config from './config';
import smartPopunders from './smartPopunders';

export default [analytics, news, config, meta, smartPopunders, faviconChanger];
